export const downloadFiles = (
  files: Blob | MediaSource,
  fileName: string,
): void => {
  const href = URL.createObjectURL(files)
  const element = document.createElement('a')

  element.href = href
  element.setAttribute('download', fileName)
  element.click()

  URL.revokeObjectURL(href)
}
